"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InvalidArgumentError = void 0;
const TutorResourcesServiceClient_1 = __importDefault(require("./TutorResourcesServiceClient"));
var errors_1 = require("@seneca/errors");
Object.defineProperty(exports, "InvalidArgumentError", { enumerable: true, get: function () { return errors_1.InvalidArgumentError; } });
exports.default = TutorResourcesServiceClient_1.default;
//# sourceMappingURL=index.js.map